import { c as _c } from "react/compiler-runtime";
import { FormInput, InputProps } from '@systemeio/ui';
import CreateSenderEmailAddressModal from 'modules/profile/mailing-settings/components/create-sender-email-address-modal';
import React, { useRef } from 'react';
interface FormSenderEmailInputProps extends InputProps {
  value: string;
}
const FormSenderEmailInput = t0 => {
  const $ = _c(16);
  let error;
  let label;
  let rest;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      label,
      error,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = error;
    $[2] = label;
    $[3] = rest;
    $[4] = value;
  } else {
    error = $[1];
    label = $[2];
    rest = $[3];
    value = $[4];
  }
  const wrapperRef = useRef(null);
  let t1;
  if ($[5] !== error || $[6] !== label || $[7] !== rest || $[8] !== value) {
    t1 = <FormInput type="email" value={value} label={label} error={error} {...rest} />;
    $[5] = error;
    $[6] = label;
    $[7] = rest;
    $[8] = value;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== error || $[11] !== value) {
    t2 = <CreateSenderEmailAddressModal wrapperRef={wrapperRef} error={error} withoutButton={true} value={value} />;
    $[10] = error;
    $[11] = value;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t1 || $[14] !== t2) {
    t3 = <div ref={wrapperRef}>{t1}{t2}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
export default FormSenderEmailInput;